import styled from 'styled-components';
import { Button } from 'client/widgets/ui';
import { observer } from 'mobx-react';
import { user, storage, hoc } from 'lib';
import { useSetState, useStateful, useBoolean } from 'react-hanger';
import { useRouter } from 'next/router';

import * as Base64 from 'js-base64';
import React, { useEffect } from 'react';
import { getGlobalStore, useGlobalStore } from 'stores';
import Icon from '../../../../components/ui/icon';
import { useStore } from './store';
import { OneLogin, ToggleLogin } from './common';
import S from './styled';

import MobileCheck from './mobile-check';
import { UiToast } from 'components';

const { Form, FormTip, FormItem, Input } = S;
const BtnSend = styled(Button)`
  margin-left: 12px;
`;

const cacheKey = 'LOGIN_USER_NAME';
const getData = () => {
  const data = storage.getItem(cacheKey) || '';
  if (data) {
    try {
      return JSON.parse(Base64.decode(data));
    } catch (e) {}
  }
  return {};
};
const saveData = (data) => {
  storage.setItem(cacheKey, Base64.encode(JSON.stringify(data)));
};

const PasswordLogin = observer((props) => {
  const { show } = props;
  const { setLoginType } = useStore();
  const tip = useStateful('');
  const isLoading = useBoolean(false);
  const isSavePassword = useBoolean(false);
  const isAutoLogin = useBoolean(false);
  const isFirstAutoLogin = useBoolean(false);

  const { isPcClient, isPcWeb } = useGlobalStore();

  const { state, setState, resetState } = useSetState({
    userName: '',
    password: '',
    scope: 'PC_WEB',
  });

  const { query } = useRouter();

  useEffect(() => {
    const data = getData();
    if (data && (data.isSavePassword || isAutoLogin.value)) {
      setState(data);
      isSavePassword.setValue(data.isSavePassword);
      isAutoLogin.setValue(data.isAutoLogin);

      // 自动登录
      if (data.isAutoLogin && !storage.getItem('SING_OUT')) {
        isFirstAutoLogin.setTrue();
      }
    }

    // hoc.render({},MobileCheck)
  }, []);

  // useEffect(() => {
  //   if (!isSavePassword.value) {
  //     const data = getData();
  //     data.isSavePassword = false;
  //     saveData(data);
  //   }
  // }, [isSavePassword.value]);
  // useEffect(() => {
  //   if (!isAutoLogin.value) {
  //     const data = getData();
  //     data.isAutoLogin = false;
  //     saveData(data);
  //   }
  // }, [isAutoLogin.value]);

  useEffect(() => {
    if (isFirstAutoLogin.value && query.redirect_from !== 'thirdLogin') {
      onLogin();
    }
  }, [isFirstAutoLogin.value, query]);

  const onLogin = (e) => {
    e && e.preventDefault();
    if (checkData() && !isLoading.value) {
      isLoading.setTrue();
      user.loginMeMe({
        ...state,
        onSuccess: (res) => {
          if (isSavePassword.value || isAutoLogin.value) {
            saveData({
              ...(isSavePassword.value || isAutoLogin.value ? state : {}),
              isSavePassword: isSavePassword.value,
              isAutoLogin: isAutoLogin.value,
            });
          } else {
            saveData({});
          }
          isLoading.setFalse();

          storage.remove('SING_OUT');

          const cb = () => {
            // const { userInfo } = getGlobalStore();
            // if (userInfo && !userInfo.isAnchor) {
            //   user.clearUserInfo();
            //   tip.setValue('登录失败，请先申请开播获得主播权限');
            //   return false;
            // }
          };
          // 需要手机验证的
          if (res.data.en_mobile && !res.data.security_checks) {
            hoc.render(
              {
                mobile: res.data.en_mobile,
                loginRes: res,
                onSuccess: cb,
              },
              MobileCheck,
            );

            return false;
          }

          return cb();
        },
        onFail: (msg) => {
          tip.setValue(msg);
          isLoading.setFalse();
        },
      });
    }
  };

  const onChange = (e) => {
    const { name, value } = e.currentTarget;

    setState({
      [name]: value.replace(/[\u4e00-\u9fa5]|\s/g, ''), // 过滤中文
    });
  };

  const checkData = () => {
    if (state.userName.length === 0) {
      tip.setValue('请输入手机号/用户名/么么号');
      return false;
    }
    if (state.password.length === 0) {
      tip.setValue('请输入密码');
      return false;
    }
    if (state.password.length < 6) {
      tip.setValue('请正确输入密码');
      return false;
    }
    tip.setValue('');
    return true;
  };

  const handleSavePassword = () => {
    isSavePassword.toggle();
    if (isSavePassword.value) {
      const data = getData();
      data.isSavePassword = false;
      saveData(data);
    }
  };
  const handleSaveAutoLogin = () => {
    isAutoLogin.toggle();
    if (isAutoLogin.value) {
      const data = getData();
      data.isAutoLogin = false;
      saveData(data);
    }
  };

  const handleForget = () => {
    UiToast.warn('请前往手机端进行忘记密码操作');
  };

  return (
    <Form show={show} onSubmit={onLogin}>
      <FormItem>
        <Input
          placeholder="请输入手机号/用户名/么么号"
          name="userName"
          value={state.userName}
          maxLength={20}
          onChange={onChange}
        ></Input>
      </FormItem>
      <FormItem>
        <Input
          placeholder="请输入密码"
          type="password"
          name="password"
          maxLength={20}
          value={state.password}
          onChange={onChange}
        ></Input>
      </FormItem>
      <FormTip>{tip.value}</FormTip>
      <FormItem>
        <S.Radio onClick={handleSavePassword} $check={isSavePassword.value}>
          <Icon type={isSavePassword.value ? 'circle-check-fill' : 'circle'}></Icon>{' '}
          <span>记住密码</span>
        </S.Radio>
        {isPcClient && (
          <S.Radio onClick={handleSaveAutoLogin} $check={isAutoLogin.value}>
            <Icon type={isAutoLogin.value ? 'circle-check-fill' : 'circle'}></Icon>{' '}
            <span>自动登录</span>
          </S.Radio>
        )}
        <span className="blank"></span>
        {isPcWeb && (
          <>
            <ToggleLogin onClick={handleForget}>忘记密码</ToggleLogin>{' '}
            <ToggleLogin className="bar">|</ToggleLogin>
          </>
        )}
        <ToggleLogin
          onClick={() => {
            setLoginType('mobile');
          }}
        >
          验证码登录
        </ToggleLogin>
      </FormItem>
      <FormItem>
        {isLoading.value ? (
          <Button type="primary" size="lg" disable round block>
            加载中...
          </Button>
        ) : (
          <Button type="primary" size="lg" round block onClick={onLogin}>
            登&nbsp;录
          </Button>
        )}
      </FormItem>
      <FormItem>
        <OneLogin></OneLogin>
      </FormItem>
    </Form>
  );
});

export default PasswordLogin;
